/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Home from './Home';
import Layout from '../../components/Layout';

async function action({ locale }) {
    const data = await new Promise(resolve => {
        require.ensure(
            [],
            require => {
                try {
                    resolve(require(`../../data/${locale}.json`)); // eslint-disable-line import/no-dynamic-require
                } catch (e) {
                    resolve(require(`../../data/en-US.json`));
                }
            },
            'home',
        );
    });
  return {
    title: 'White Code',
    chunks: ['home'],
    component: (
      <Layout>
        <Home />
          {console.log(locale)}
      </Layout>
    ),
  };
}

export default action;
